import { useAuthStore } from "@persisted-state/auth/auth.store";
import { paths } from "@utils/navigation";

const MANAGING_DIRECTOR_ROLE = "managing-director-office";
const SERVICE_DESK_ROLE = "service-desk";
const VENDOR_MASTER_ROLE = "vendor-master";
const LICENSED_COMPANY_AGENT_ROLE = "licensed-company-agent";

export const useNotificationDetailsPath = (
  relatedEntityId?: string,
  relatedEntityType: "PORT_OPERATOR_LICENSE" | "VENDOR_LICENSE" = "PORT_OPERATOR_LICENSE",
): string | null => {
  if (!relatedEntityId) return null;

  const userRoles = useAuthStore.getState().user?.roles ?? [];
  const isManagingDirectorOffice = userRoles.includes(MANAGING_DIRECTOR_ROLE);
  const isServiceDesk = userRoles.includes(SERVICE_DESK_ROLE);
  const isVendorMaster = userRoles.includes(VENDOR_MASTER_ROLE);
  const isLicensedCompanyAgent = userRoles.includes(LICENSED_COMPANY_AGENT_ROLE);

  if (relatedEntityType === "VENDOR_LICENSE") {
    return `/${
      isServiceDesk ? paths.licenses.accountIndex : paths.licenses.index
    }/${paths.licenses.licenseDetailsById.replace(":id", relatedEntityId)}`;
  }

  if (isManagingDirectorOffice) {
    return `/${paths.licenses.portOperatorIndex}/${paths.licenses.licenseDetailsById.replace(
      ":id",
      relatedEntityId,
    )}`;
  }

  if (isVendorMaster || isLicensedCompanyAgent) {
    return `/${paths.licenses.index}/${paths.licenses.licenseDetailsById.replace(
      ":id",
      relatedEntityId,
    )}?licenseType=PORT_OPERATOR_LICENSE`;
  }

  return `/${paths.licenses.portOperatorIndex}/${paths.licenses.licenseDetailsById.replace(
    ":id",
    relatedEntityId,
  )}`;
};
